// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YYmW8","select":"styles_select__2VxnT"};